const get_started = {
    page_title: 'Começar',
    title: 'Algo para explorar para ajudá-lo a ter sucesso',
    subtitle: 'Algumas coisas que você pode fazer para obter rapidamente valor do Logto',
    develop: {
        title: 'Desenvolva: Dedique 5 minutos para integrar o seu aplicativo',
        title_cloud: 'Desenvolver: Integre com segurança seu aplicativo em minutos',
        subtitle_cloud: 'Ou leve 5 minutos para integrar seu aplicativo com nossos SDKs pré-construídos e tutoriais.',
        try_mcp: 'Experimente a integração com um único prompt usando o MCP',
    },
    customize: {
        title: 'Personalize: Ofereça uma ótima experiência de login',
        preview: {
            title: 'Verifique a visualização ao vivo da experiência de login que você acabou de personalizar',
            subtitle: 'Experimente agora a experiência de login do Logto para ver como ela funciona',
        },
        connector: {
            title: 'Adicione mais conectores para oferecer mais métodos de login social',
            subtitle: 'Experimente o login sem senha e habilite uma experiência segura e sem atritos para seus clientes',
        },
        continue_customizing: 'Continuar personalizando',
        try_now: 'Experimente agora',
        add_more: 'Adicionar mais',
    },
    secure: {
        title: 'Segurança: Proteja seus recursos',
    },
    manage: {
        title: 'Gerencie: Defina o controle de acesso para seu produto e usuários',
        rbac: {
            title: 'Adicione controle de acesso baseado em funções para proteger seus recursos',
            subtitle: 'Controle seus recursos por meio de autorização baseada em função escalável para diversos casos de uso.',
        },
        create_roles: 'Criar funções',
    },
    convert_to_production: {
        card_title: 'Pronto para ir ao ar? Não se esqueça de lançar sua configuração de produção!',
        title: 'Não mantenha seu projeto preso no modo de desenvolvimento',
        subtitle: 'Você está usando um tenant de desenvolvimento para testes gratuitos. Para ir ao ar, crie ou converta para um tenant de produção. Precisa de algo personalizado? <a>Entre em contato conosco</a>',
        convert_button: 'Converter para tenant de produção',
    },
    oss_cloud: {
        try: {
            title: 'Deixe o trabalho operacional de lado e experimente o Logto Cloud grátis',
            badge: 'Recomendado',
            description: 'Tenha um Logto totalmente gerenciado sem manutenção, além de integração rápida com MCP, suporte a múltiplos tenants, colaboração em equipe e todos os recursos premium incluídos. Comece grátis, sem cartão de crédito.',
            action: 'Explorar o Logto Cloud',
        },
        private_cloud: {
            title: 'Precisa de conformidade ou de uma implantação personalizada?',
            card_title: 'Nuvem privada',
            description: 'Tenha uma instância dedicada do Logto com isolamento total de dados, domínio personalizado e garantias de SLA. Ideal para empresas com requisitos rigorosos de residência de dados ou conformidade. Nós cuidamos da infraestrutura para que você possa focar no seu produto.',
        },
    },
    view_all: 'Ver todos →',
};
export default Object.freeze(get_started);
